import { compose as a } from "../../tailwind-buddy-interface.js";
const t = {
  // variant="contained" / isDisabled="false" / isDisabledFocusable="false"
  variantContainedIsDisabledFalseIsDisabledFocusableFalse: `
    hover:-translate-y-006
    active:translate-y-006
  `,
  // variant="contained"
  variantContained: "backdrop-blur-lg",
  // variant="text"
  variantText: "hover:backdrop-blur-lg",
  // variant="contained" / appearance="default"
  variantContainedAppearanceDefault: `
    bg-color-elevation-flat-glass
    shadow-elevation-flat
    hover:bg-color-elevation-raised-canvas
    hover:shadow-elevation-raised
    active:bg-color-elevation-flat-glass
    active:shadow-elevation-flat
  `,
  // variant="contained" / appearance="primary"
  variantContainedAppearancePrimary: `
    bg-color-scheme-brand-primary-500
    shadow-sm
    hover:bg-color-scheme-brand-primary-400
    hover:shadow-sm
    active:bg-color-scheme-brand-primary-600
    [&:not(:focus-visible)]:active:shadow-none
  `,
  // variant="contained" / appearance="destructive"
  variantContainedAppearanceDestructive: `
    bg-color-elevation-flat-glass
    shadow-elevation-flat
    hover:bg-color-elevation-raised-canvas
    hover:shadow-elevation-raised
    active:bg-color-elevation-flat-glass
    active:shadow-elevation-flat
  `,
  // variant="text" / appearance="default"
  variantTextAppearanceDefault: `
    bg-color-static-transparent
    hover:bg-color-scheme-neutral-100
    active:bg-color-scheme-neutral-200
  `,
  // variant="text" / appearance="primary"
  variantTextAppearancePrimary: `
    bg-color-static-transparent
    hover:bg-color-scheme-brand-primary-100
    active:bg-color-scheme-brand-primary-200
  `,
  // variant="text" / appearance="destructive"
  variantTextAppearanceDestructive: `
    bg-color-static-transparent
    hover:bg-color-scheme-functional-negative-100
    active:bg-color-scheme-functional-negative-200
  `,
  // variant="contained" / appearance="default" / enableGroupHover="true"
  variantContainedAppearanceDefaultEnableGroupHover: `
    group-hover/button:[&:not(:active)]:bg-color-elevation-raised-canvas
    group-hover/button:[&:not(:active)]:shadow-elevation-raised
  `,
  // variant="contained" / appearance="primary" / enableGroupHover="true"
  variantContainedAppearancePrimaryEnableGroupHover: `
    group-hover/button:[&:not(:active)]:bg-color-scheme-brand-primary-400
    group-hover/button:[&:not(:active)]:shadow-sm
  `,
  // variant="contained" / appearance="destructive" / enableGroupHover="true"
  variantContainedAppearanceDestructiveEnableGroupHover: `
    group-hover/button:[&:not(:active)]:bg-color-elevation-raised-canvas
    group-hover/button:[&:not(:active)]:shadow-elevation-raised
  `,
  // variant="text" / appearance="default" / enableGroupHover="true"
  variantTextAppearanceDefaultEnableGroupHover: "group-hover/button:[&:not(:active)]:bg-color-film-secondary",
  // variant="text" / appearance="primary" / enableGroupHover="true"
  variantTextAppearancePrimaryEnableGroupHover: "group-hover/button:[&:not(:active)]:bg-color-scheme-brand-primary-100",
  // variant="text" / appearance="destructive" / enableGroupHover="true"
  variantTextAppearanceDestructiveEnableGroupHover: "group-hover/button:[&:not(:active)]:bg-color-scheme-functional-negative-100",
  // variant="contained" / isDisabled="true"
  variantContainedIsDisabled: `
    bg-color-scheme-interactive-disabled-100
    outline
    outline-width-sm
    outline-color-scheme-interactive-disabled-200
  `,
  // variant="contained" / isDisabledFocusable="true"
  variantContainedIsDisabledFocusable: `
    bg-color-scheme-interactive-disabled-100
    outline
    outline-width-sm
    outline-color-scheme-interactive-disabled-200
  `,
  // variant="text" / isDisabled="true"
  variantTextIsDisabled: "bg-color-static-transparent",
  // variant="text" / isDisabledFocusable="true"
  variantTextIsDisabledFocusable: "bg-color-static-transparent"
}, e = t, r = a({
  slots: {
    root: `
      inline-flex
      items-center
      justify-center
      max-w-full
    `,
    label: "",
    icon: "shrink-0"
  },
  variants: {
    /** Sets the button appearance. */
    appearance: {
      default: {},
      primary: {},
      destructive: {}
    },
    /** Sets the button size. */
    size: {
      xs: {
        root: `
          ps-075
          pe-075
          py-050
          rounded-xs
        `,
        label: `
          ps-050
          pe-050
          py-000
          font-weight-bold
          leading-100
          text-size-75
        `
      },
      sm: {
        root: `
          ps-100
          pe-100
          py-100
          rounded-sm
        `,
        label: `
          ps-050
          pe-050
          py-000
          font-weight-bold
          leading-100
          text-size-87
        `
      },
      md: {
        root: `
          ps-150
          pe-150
          py-100
          rounded-sm
        `,
        label: `
          ps-050
          pe-050
          py-025
          font-weight-bold
          leading-125
          text-size-100
        `
      },
      lg: {
        root: `
          ps-150
          pe-150
          py-150
          rounded-md
        `,
        label: `
          ps-100
          pe-100
          py-025
          font-weight-bold
          leading-125
          text-size-112
        `
      },
      xl: {
        root: `
          ps-200
          pe-200
          py-150
          rounded-md
        `,
        label: `
          ps-100
          pe-100
          py-075
          font-weight-bolder
          leading-125
          text-size-112
        `
      }
    },
    /** Sets the button variant. */
    variant: {
      contained: "",
      text: ""
    }
  },
  compoundVariants: [
    // variant="contained" / isDisabled="false" / isDisabledFocusable="false"
    {
      conditions: {
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: e.variantContainedIsDisabledFalseIsDisabledFocusableFalse
      }
    },
    // variant="contained"
    {
      conditions: {
        variant: "contained"
      },
      class: {
        root: e.variantContained
      }
    },
    // variant="text"
    {
      conditions: {
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: e.variantText
      }
    },
    // variant="contained" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantContainedAppearanceDefault}
          text-color-primary
          hover:text-color-primary
          active:text-color-secondary
        `,
        icon: "text-icon-color-primary"
      }
    },
    // variant="contained" / appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantContainedAppearancePrimary}
          text-color-primary-inverse
          hover:text-color-primary-inverse
          active:text-color-primary-inverse
        `,
        icon: "text-icon-color-primary-inverse"
      }
    },
    // variant="contained" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantContainedAppearanceDestructive}
          text-color-scheme-functional-negative-600
          hover:text-color-scheme-functional-negative-600
          active:text-color-scheme-functional-negative-600
        `,
        icon: "text-color-scheme-functional-negative-500"
      }
    },
    // variant="text" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantTextAppearanceDefault}
          text-color-primary
          hover:text-color-primary
          active:text-color-primary
        `,
        icon: "text-icon-color-primary"
      }
    },
    // variant="text" + appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantTextAppearancePrimary}
          text-color-scheme-brand-primary-600
          hover:text-color-scheme-brand-primary-800
          active:text-color-scheme-brand-primary-800
        `,
        icon: "text-color-scheme-brand-primary-500"
      }
    },
    // variant="text" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantTextAppearanceDestructive}
          text-color-scheme-functional-negative-600
          hover:text-color-scheme-functional-negative-800
          active:text-color-scheme-functional-negative-800
        `,
        icon: "text-color-scheme-functional-negative-500"
      }
    },
    // variant="contained" / appearance="default" / enableGroupHover="true"
    {
      conditions: {
        appearance: "default",
        variant: "contained",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantContainedAppearanceDefaultEnableGroupHover}
          group-hover/button:[&:not(:active)]:text-color-primary
        `
      }
    },
    // variant="contained" / appearance="primary" / enableGroupHover="true"
    {
      conditions: {
        appearance: "primary",
        variant: "contained",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantContainedAppearancePrimaryEnableGroupHover}
          group-hover/button:[&:not(:active)]:text-color-primary-inverse
        `
      }
    },
    // variant="contained" / appearance="destructive" / enableGroupHover="true"
    {
      conditions: {
        appearance: "destructive",
        variant: "contained",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantContainedAppearanceDestructiveEnableGroupHover}
          group-hover/button:[&:not(:active)]:text-color-scheme-functional-negative-600
        `
      }
    },
    // variant="text" / appearance="default" / enableGroupHover="true"
    {
      conditions: {
        appearance: "default",
        variant: "text",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantTextAppearanceDefaultEnableGroupHover}
          group-hover/button:[&:not(:active)]:text-color-primary
        `
      }
    },
    // variant="text" / appearance="primary" / enableGroupHover="true"
    {
      conditions: {
        appearance: "primary",
        variant: "text",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantTextAppearancePrimaryEnableGroupHover}
          group-hover/button:[&:not(:active)]:text-color-scheme-brand-primary-800
        `
      }
    },
    // variant="text" / appearance="destructive" / enableGroupHover="true"
    {
      conditions: {
        appearance: "destructive",
        variant: "text",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: `
          ${e.variantTextAppearanceDestructiveEnableGroupHover}
          group-hover/button:[&:not(:active)]:text-color-scheme-functional-negative-800
        `
      }
    },
    // variant="contained" / isDisabled="true"
    {
      conditions: {
        variant: "contained",
        isDisabled: !0
      },
      class: {
        root: `
          ${e.variantContainedIsDisabled}
          text-color-scheme-interactive-disabled-400
        `,
        icon: "text-color-scheme-interactive-disabled-400"
      }
    },
    // variant="contained" / isDisabledFocusable="true"
    {
      conditions: {
        variant: "contained",
        isDisabledFocusable: !0
      },
      class: {
        root: `
          ${e.variantContainedIsDisabledFocusable}
          text-color-scheme-interactive-disabled-400
        `,
        icon: "text-color-scheme-interactive-disabled-400"
      }
    },
    // variant="text" / isDisabled="true"
    {
      conditions: {
        variant: "text",
        isDisabled: !0
      },
      class: {
        root: `
          ${e.variantTextIsDisabled}
          text-color-scheme-interactive-disabled-400
        `,
        icon: "text-color-scheme-interactive-disabled-400"
      }
    },
    // variant="text" / isDisabledFocusable="true "
    {
      conditions: {
        variant: "text",
        isDisabledFocusable: !0
      },
      class: {
        root: `
          ${e.variantTextIsDisabledFocusable}
          text-color-scheme-interactive-disabled-400
        `,
        icon: "text-color-scheme-interactive-disabled-400"
      }
    }
  ],
  defaultVariants: {
    appearance: "default",
    size: "md",
    variant: "contained"
  },
  responsiveVariants: ["size"]
})();
export {
  t as buttonRootCommonStyles,
  r as buttonVariants
};
